<template>
  <div class="security-input-box">
    <el-input
      v-for="i in count"
      :key="i"
      :ref="`securityInputRef-${i - 1}`"
      class="security-input-item"
      :class="bgColor"
      v-model="values[i - 1]"
      :type="type"
      :autofocus="autofocus && i === 1"
      @keydown.native="handleKeydown(i - 1, $event)"
      @input="handleItemInput(i - 1, $event)"
    ></el-input>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default: 6,
    },
    type: {
      type: String,
      default: 'text',
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    bgColor: {
      type: String,
      default: 'dark',
    },
  },
  data() {
    return {
      values: [],
    };
  },
  created() {
    this.values = Array(this.count).fill('');
  },
  methods: {
    handleItemInput(index, value) {
      if (!value) { // 删除
        if (index > 0) {
          this.onFocus(index - 1);
        }
        this.$emit('change', this.values.join(''));
        return;
      }
      const v = value.match(/^\d*/g)[0];
      this.values[index] = `${v}`.charAt(`${v}`.length - 1);
      if (!this.values[index]) {
        return;
      }
      const next = index + 1;
      if (next < this.values.length) {
        this.onFocus(next);
      } else {
        this.onBlur(index);
      }
      this.$emit('change', this.values.join(''));
    },
    handleKeydown(index, e) {
      if (!this.values[index] && e.key === 'Backspace') {
        if (index > 0) {
          this.onFocus(index - 1);
        }
      }
    },
    onFocus(index) {
      const key = `securityInputRef-${index}`;
      const ref = this.$refs[key];
      const clz = Object.prototype.toString.call(ref).slice(8, -1);
      let obj = ref;
      if (clz === 'Array') {
        obj = ref[0];
      }
      obj && obj.focus();
    },
    onBlur(index) {
      const key = `securityInputRef-${index}`;
      const ref = this.$refs[key];
      const clz = Object.prototype.toString.call(ref).slice(8, -1);
      let obj = ref;
      if (clz === 'Array') {
        obj = ref[0];
      }
      obj && obj.blur();
    },
    reset() {
      this.values = Array(this.count).fill('');
    },
  },
};
</script>

<style lang="scss" scoped>
.security-input-box {
  display: flex;
  align-items: center;

  .security-input-item {
    width: 50px;
    height: 60px;
    margin-right: 8px;
    box-sizing: border-box;

    &.white {
      background-color: white;
      ::v-deep .el-input__inner {
        background-color: white;
        border: none;
      }
    }

    ::v-deep .el-input__inner {
      height: 100%;
      text-align: center;
      font-size: 18px;
      padding-left: 0;
      padding-right: 0;
      font-weight: 600;
    }
  }
}
</style>
